import { FilterMatchMode, FilterService } from 'primereact/api';

FilterService.register('custom_viaje', (value, filter) => {
  if (filter === null || filter === undefined || filter.trim() === '') {
    return true;
  }

  if (value === null || value === undefined) {
    return false;
  }

  const lowerCaseValue = value.toString().toLowerCase();
  const lowerCaseFilter = filter.toString().toLowerCase();

  return (
    lowerCaseValue.localeCompare(lowerCaseFilter, 'es', {
      sensitivity: 'accent',
    }) === 0 || lowerCaseValue.includes(lowerCaseFilter)
  );
});

export const matchModes = [{ label: 'viaje', value: 'custom_viaje' }];

export const tableFilters = {
  entregados: { value: null, matchMode: FilterMatchMode.CONTAINS },
  entregadosSpecified: { value: null, matchMode: FilterMatchMode.CONTAINS },
  preasignados: { value: null, matchMode: FilterMatchMode.CONTAINS },
  preasignadosSpecified: { value: null, matchMode: FilterMatchMode.CONTAINS },
  reposicionVacios: { value: null, matchMode: FilterMatchMode.CONTAINS },
  reposicionVaciosSpecified: {
    value: null,
    matchMode: FilterMatchMode.CONTAINS,
  },
  tipo: { value: null, matchMode: FilterMatchMode.CONTAINS },
  tamano: { value: null, matchMode: FilterMatchMode.CONTAINS },
  transito: { value: null, matchMode: FilterMatchMode.CONTAINS },
  transitoSpecified: { value: null, matchMode: FilterMatchMode.CONTAINS },
  viaje: { value: null, matchMode: FilterMatchMode.CUSTOM },
  inicioOps: { value: null, matchMode: FilterMatchMode.DATE_IS },
};
